var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0675 15.1828C16.1256 15.2409 16.1717 15.3098 16.2031 15.3857C16.2345 15.4615 16.2507 15.5429 16.2507 15.625C16.2507 15.7071 16.2345 15.7884 16.2031 15.8643C16.1717 15.9402 16.1256 16.0091 16.0675 16.0672C16.0095 16.1252 15.9405 16.1713 15.8647 16.2027C15.7888 16.2342 15.7075 16.2503 15.6253 16.2503C15.5432 16.2503 15.4619 16.2342 15.386 16.2027C15.3102 16.1713 15.2412 16.1252 15.1832 16.0672L10.0003 10.8836L4.81753 16.0672C4.70026 16.1844 4.5412 16.2503 4.37535 16.2503C4.2095 16.2503 4.05044 16.1844 3.93316 16.0672C3.81588 15.9499 3.75 15.7908 3.75 15.625C3.75 15.4591 3.81588 15.3001 3.93316 15.1828L9.11675 9.99998L3.93316 4.81717C3.81588 4.69989 3.75 4.54083 3.75 4.37498C3.75 4.20913 3.81588 4.05007 3.93316 3.93279C4.05044 3.81552 4.2095 3.74963 4.37535 3.74963C4.5412 3.74963 4.70026 3.81552 4.81753 3.93279L10.0003 9.11639L15.1832 3.93279C15.3004 3.81552 15.4595 3.74963 15.6253 3.74963C15.7912 3.74963 15.9503 3.81552 16.0675 3.93279C16.1848 4.05007 16.2507 4.20913 16.2507 4.37498C16.2507 4.54083 16.1848 4.69989 16.0675 4.81717L10.8839 9.99998L16.0675 15.1828Z",
    fill: "#6A727B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalX);
export default __webpack_public_path__ + "static/media/modal-x.5e2dcd7c1aaf2ee877fa9da9487269ef.svg";
export { ForwardRef as ReactComponent };